import { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const navLinks = [
{ label: "Contenido", href: "#contenido" },
{ label: "Herramientas", href: "#herramientas" },
{ label: "Comunidad", href: "#comunidad" },
{ label: "Planes", href: "#planes" },
{ label: "FAQ", href: "#faq" }];


export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById("formulario")?.scrollIntoView({ behavior: "smooth" });
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      "bg-[#0A1628]/95 backdrop-blur-lg shadow-lg" :
      "bg-transparent"}`
      }>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3">
            <span
              className="text-2xl font-bold text-white tracking-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}>

              DSA
            </span>
            <span className="hidden sm:inline text-xs uppercase tracking-[0.2em] text-gray-400 border-l border-gray-600 pl-3">Economía digital

            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link, index) =>
            <button
              key={index}
              onClick={() => handleNavClick(link.href)}
              className="text-sm text-gray-300 hover:text-white transition-colors">

                {link.label}
              </button>
            )}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <button
              onClick={scrollToForm}
              data-testid="nav-cta"
              className="group bg-[#D4C4A8] text-[#0A1628] px-6 py-2.5 text-sm font-bold hover:bg-white transition-all tracking-wide flex items-center gap-2">

              Solicitar Info
              <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="lg:hidden bg-[#0A1628] border-t border-white/10">
          <div className="px-6 py-6 space-y-4">
            {navLinks.map((link, index) =>
          <button
            key={index}
            onClick={() => handleNavClick(link.href)}
            className="block w-full text-left text-base text-gray-300 hover:text-white py-2 transition-colors">

                {link.label}
              </button>
          )}
            <div className="pt-4 border-t border-white/10">
              <button
              onClick={scrollToForm}
              className="w-full bg-[#D4C4A8] text-[#0A1628] px-6 py-3 text-sm font-bold hover:bg-white transition-all tracking-wide">

                Solicitar Información
              </button>
            </div>
          </div>
        </div>
      }
    </nav>);

}